import React, { useCallback, useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';

import { ContainerClients, ContainerLoading } from './style.js';
import Loading from '../../../assets/loading.json';
import Lottie from 'react-lottie';
import Menu from '../../../components/Menu/index.js';
import Footer from '../../../components/Footer/index.js';
import AuthGuard from '../../../components/AuthGuard/index.js';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import api from '../../../services/api.js';

import ButtonDefault from '../../../components/ButtonDefault/index.js';
import SelectDefault from '../../../components/SelectDefault/index.js';
import InputDefault from '../../../components/InputDefault/index.js';

const DistributionFeeEdit = () => {
  const loadingAnimation = {
    loop: true,
    autoplay: true,
    animationData: Loading
  };

  const { id } = useParams();

  document.title = 'Datamais - Editar Tarifa por Distribuidora';

  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [idDm005, setIdDm005] = useState(0);
  const [idDm003, setIdDm003] = useState(0);
  const [idDm003List, setIdDm003List] = useState(0);
  const [prPisCofins, setPrPisCofins] = useState(0.0);
  const [prIcmsReduzido, setPrIcmsReduzido] = useState(0.0);
  const [prIcmsIntegral, setPrIcmsIntegral] = useState(0.0);
  const [vlTsud, setVlTsud] = useState(0.0);
  const [vlTe, setVlTe] = useState(0.0);
  const [vlFiob, setVlFiob] = useState(0.0);
  const [prFiob, setPrFiob] = useState(0.0);
  const [transitionAmount, setTransitionAmount] = useState(0.0);

  const handleSendDistFee = useCallback(async () => {
    const data = {
      ID_DM003: parseInt(idDm003),
      PR_PIS_COFINS: parseFloat(prPisCofins.replace(',', '.')),
      PR_ICMS_REDUZIDO: parseFloat(prIcmsReduzido.replace(',', '.')),
      PR_ICMS_INTEGRAL: parseFloat(prIcmsIntegral.replace(',', '.')),
      VL_TSUD: parseFloat(vlTsud.replace(',', '.')),
      VL_TE: parseFloat(vlTe.replace(',', '.')),
      VL_FIOB: parseFloat(vlFiob.replace(',', '.')),
      PR_FIOB: parseFloat(prFiob.replace(',', '.')),
      QT_MONTANTE_TRANSICAO_KWH: parseFloat(transitionAmount)
    };
    console.log(data);
    api
      .put(`distribution_fee?id=${id}`, data)
      .then((response) => {
        if (response.status === 201) {
          toast.success('Tarifa por Distribuidora alterada com sucesso!', {
            autoClose: 3000,
            onClose: () => {
              navigate('/distribution_fee/list');
            }
          });
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        console.log(error.response.data.error);
        toast.error(error.response.data.message);
      });
  }, [
    idDm003,
    prPisCofins,
    prIcmsReduzido,
    prIcmsIntegral,
    vlTsud,
    vlTe,
    vlFiob,
    prFiob,
    transitionAmount
  ]);

  useEffect(() => {
    api
      .get(`supplier?situacao=A`)
      .then((response) => {
        if (response.status === 200) {
          setIdDm003List(response.data.data);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .then(() => {
        api
          .get(`distribution_fee?id=${id}`)
          .then((response) => {
            console.log(response.data.data);
            if (response.status === 200) {
              setIdDm005(response.data.data[0].ID_DM005);
              setIdDm003(response.data.data[0].ID_DM003);
              setPrPisCofins(formatNumber(response.data.data[0].PR_PIS_COFINS));
              setPrIcmsReduzido(formatNumber(response.data.data[0].PR_ICMS_REDUZIDO));
              setPrIcmsIntegral(formatNumber(response.data.data[0].PR_ICMS_INTEGRAL));
              setVlTsud(formatNumber(response.data.data[0].VL_TSUD));
              setVlTe(formatNumber(response.data.data[0].VL_TE));
              setVlFiob(formatNumber(response.data.data[0].VL_FIOB));
              setPrFiob(formatNumber(response.data.data[0].PR_FIOB));
              setTransitionAmount(formatNumber(response.data.data[0].QT_MONTANTE_TRANSICAO_KWH));
              setIsLoading(false);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
  }, []);

  const formatNumber = (number) => {
    return Number(number).toFixed(2);
  };

  return (
    <>
      <AuthGuard />
      <Menu />
      {isLoading ? (
        <ContainerLoading>
          <Lottie options={loadingAnimation} style={{ width: '100%', height: 400 }} />
          <h1>Carregando Tarifa por Distribuidora...</h1>
        </ContainerLoading>
      ) : (
        <>
          <Container>
            <ContainerClients>
              <h2>Editar Tarifa por Distribuidora #{id} </h2>
              <Row>
                <div
                  style={{
                    border: '1px solid',
                    borderRadius: '10px',
                    marginTop: '30px'
                  }}>
                  <p
                    style={{
                      marginTop: '-12px',
                      background: '#f1f1f1',
                      display: 'table',
                      padding: '0px 5px 0px 5px'
                    }}>
                    Dados da Tarifa
                  </p>
                  <Row>
                    <Col xs={3}>
                      <SelectDefault
                        Text="Distribuidora"
                        Margin={'15px 15px 15px 0px'}
                        Width={'100%'}
                        value={idDm003}
                        onChange={(e) => setIdDm003(e.target.value)}>
                        {idDm003List && idDm003List.length > 0 ? (
                          idDm003List.map((item) => (
                            <option key={item.ID_DM003} value={item.ID_DM003}>
                              {item.NM_DISTRIBUIDORA} ({item.ID_DM003})
                            </option>
                          ))
                        ) : (
                          <option disabled>Carregando lista...</option>
                        )}
                      </SelectDefault>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} md={2}>
                      <InputDefault
                        placeholder="%"
                        Width={'100%'}
                        Margin={'15px 15px 15px 0px'}
                        value={prPisCofins}
                        onChange={(e) => setPrPisCofins(e.target.value)}
                        Text={'% PIS/COFINS'}
                        type={'number'}
                      />
                    </Col>
                    <Col xs={12} md={2}>
                      <InputDefault
                        placeholder="%"
                        Width={'100%'}
                        Margin={'15px 15px 15px 0px'}
                        value={prIcmsReduzido}
                        onChange={(e) => setPrIcmsReduzido(e.target.value)}
                        Text={'% ICMS Reduzido'}
                        type={'number'}
                      />
                    </Col>
                    <Col xs={12} md={2}>
                      <InputDefault
                        placeholder="%"
                        Width={'100%'}
                        Margin={'15px 15px 15px 0px'}
                        value={prIcmsIntegral}
                        onChange={(e) => setPrIcmsIntegral(e.target.value)}
                        Text={'% ICMS Integral'}
                        type={'number'}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} md={3}>
                      <InputDefault
                        placeholder="Valor"
                        Width={'100%'}
                        Margin={'15px 15px 15px 0px'}
                        value={vlTsud}
                        onChange={(e) => setVlTsud(e.target.value)}
                        Text={'Valor TUSD / MWh'}
                        type={'number'}
                      />
                    </Col>
                    <Col xs={12} md={2}>
                      <InputDefault
                        placeholder="Valor"
                        Width={'100%'}
                        Margin={'15px 15px 15px 0px'}
                        value={vlTe}
                        onChange={(e) => setVlTe(e.target.value)}
                        Text={'Valor TE / MWh'}
                        type={'number'}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} md={3}>
                      <InputDefault
                        placeholder="Valor"
                        Width={'100%'}
                        Margin={'15px 15px 15px 0px'}
                        value={vlFiob}
                        onChange={(e) => setVlFiob(e.target.value)}
                        Text={'Valor FIOB / MWh'}
                        type={'number'}
                      />
                    </Col>
                    <Col xs={12} md={3}>
                      <InputDefault
                        placeholder="%"
                        Width={'100%'}
                        Margin={'15px 15px 15px 0px'}
                        value={prFiob}
                        onChange={(e) => setPrFiob(e.target.value)}
                        Text={'% FIOB'}
                        type={'number'}
                      />
                    </Col>
                    <Col xs={12} md={3}>
                      <InputDefault
                        placeholder="Valor"
                        Width={'100%'}
                        Margin={'15px 15px 15px 0px'}
                        value={transitionAmount}
                        onChange={(e) => setTransitionAmount(e.target.value)}
                        Text={'Montante de transição (kWh)'}
                        type={'number'}
                      />
                    </Col>
                  </Row>
                </div>
              </Row>
              <Row>
                <ButtonDefault
                  Width={'150px'}
                  Margin={'20px 30px 30px 0px'}
                  Text="Salvar"
                  onClick={() => {
                    handleSendDistFee();
                  }}
                />
                <ButtonDefault
                  Width={'150px'}
                  Margin={'20px 30px 30px 0px'}
                  Text="Cancelar"
                  onClick={() => {
                    navigate('/distribution_fee/list');
                  }}
                />
              </Row>
            </ContainerClients>
            <ToastContainer />
          </Container>
          <Footer />
        </>
      )}
    </>
  );
};

export default DistributionFeeEdit;
